import IRoute from 'Shared/Routes/Models/IRoute';

import LandingRoute from './LandingRoute/LandingRoute';

const LandingRoutes: IRoute[][] = [LandingRoute];

export default LandingRoutes;
